var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Paginator',{attrs:{"pagination":_vm.products,"allow-per-page-change":true},on:{"change-page":function($event){return _vm.fetch($event.page, $event.perPage)}}})}
var staticRenderFns = []

export { render, staticRenderFns }